import { UAParser } from 'ua-parser-js';

import { getBrowserInfo } from '../browser/getBrowserInfo';
import { DEFAULT_USER_AGENT } from './device.constants';

interface IDeviceInfo {
  device: string;
  isSafari: boolean;
  isFF: boolean;
  isChrome: boolean;
  isElectron: boolean;
  isMobile: boolean;
  isTablet: boolean;
}

export interface IDeviceBrowserInfo {
  isSafari: boolean;
  isFF: boolean;
  isChrome: boolean;
  isElectron: boolean;
}

export function getDeviceBrowserInfo(): IDeviceBrowserInfo {
  const { name = '' } = getBrowserInfo() ?? {};

  return {
    isSafari: name === 'Safari',
    isFF: name === 'Firefox',
    isChrome: ['Opera', 'Yandex Browser', 'Vivaldi', 'Chromium', 'Chrome'].includes(name),
    isElectron: name === 'Electron',
  };
}

export function getDeviceInfo(userAgent: string = DEFAULT_USER_AGENT): IDeviceInfo {
  const browserInfo = getBrowserInfo(userAgent);

  const parser = new UAParser(userAgent);
  const parsedDevice = parser.getDevice();

  return {
    device: browserInfo
      ? [browserInfo.name, browserInfo.version].filter(Boolean).join(' ')
      : 'unsupported',
    isMobile: parsedDevice?.type === UAParser.DEVICE.MOBILE,
    isTablet: parsedDevice?.type === UAParser.DEVICE.TABLET,
    isSafari: browserInfo?.name === 'Safari',
    isFF: browserInfo?.name === 'Firefox',
    isChrome: ['Opera', 'Yandex Browser', 'Vivaldi', 'Chromium', 'Chrome'].includes(
      browserInfo?.name || ''
    ),
    isElectron: browserInfo?.name === 'Electron',
  };
}
